<template>
  <v-container id="page-voucher-usage-detail">
    <div class="page-title">{{$route.name}}</div>
    <v-row>
      <v-col class="d-flex justify-end">
				<c-btn class="mx-1" color="blue" outlined @click="updateExpirationDateDialog = true" iconName="mdi-pencil">만료일 수정</c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="$router.go(-1)" iconName="mdi-format-list-bulleted-square">돌아가기</c-btn>
      </v-col>
    </v-row>
		<v-row>
			<v-col cols="12" md="12" sm="12">
				<c-card outlined>
					<v-row>
						<v-col cols="12" class="pt-0">
							<c-card>
								<div class="page-title mb-3 font-weight-bold">바우처 정보</div>
								<v-divider class="mt-3 mb-3"></v-divider>
								<v-row justify="space-around" align="center">
									<div style="width: calc(100% - 250px); margin-left:30px;">
										<v-row align="center">
											<v-col cols="12" sm="6" md="2">
												<span>바우처 명</span>
											</v-col>
											<v-col cols="12" sm="6" md="10" class="pt-0">
												<span class="black--text">{{ this.voucherStateInfo.voucherId ? this.voucherStateInfo.voucherId.name : '' }}</span>
											</v-col>
											<v-col cols="12" sm="6" md="2">
												<span>발급 대상</span>
											</v-col>
											<v-col cols="12" sm="6" md="4">
												<span style="cursor: pointer" @click="$router.push(`/customers/${voucherStateInfo.customerId.id}`)" class="black--text">{{ this.voucherStateInfo.voucherId ? this.voucherStateInfo.customerId.name : '' }}</span>
											</v-col>
											<v-col cols="12" sm="6" md="2">
												<span>담당자</span>
											</v-col>
											<v-col cols="12" sm="6" md="4">
												<span class="black--text">{{ this.voucherStateInfo.voucherId ? (this.voucherStateInfo.adminId ? this.voucherStateInfo.adminId.name : '-') : '' }}</span>
											</v-col>
										</v-row>
										<v-divider class="mt-3 mb-3"></v-divider>
										<v-row align="center">
											<v-col cols="12" sm="6" md="2">
												<span>지급일</span>
											</v-col>
											<v-col cols="12" sm="6" md="4">
													<span class="black--text"> {{ this.voucherStateInfo.issueDate }}</span>
											</v-col>
											<v-col cols="12" sm="6" md="2">
												<span>만료일</span>
											</v-col>
											<v-col cols="12" sm="6" md="4">
													<span v-if="this.updateExpirationDateDialog === false" class="black--text"> {{ this.voucherStateInfo.expirationDate }}</span>
													<v-menu
														v-else
														v-model="expiredMenu"
														:close-on-content-click="false"
														:nudge-right="40"
														transition="scale-transition"
														offset-y
														min-width="290px"
													>
														<template v-slot:activator="{ on }">
															<div style="width: 200px; display: inline-block;">
																<v-text-field
																	v-model="expiredDate"
																	label="만료일"
																	prepend-icon="event"
																	readonly
																	v-on="on"
																></v-text-field>
															</div>
														</template>
														<c-date-picker v-model="expiredDate" @input="expiredMenu = false" firstDayOfWeek="1" :selectedDate="expiredDate" locale="ko-kr"></c-date-picker>
													</v-menu>
													<c-btn v-if="this.updateExpirationDateDialog === true" class="mx-1" color="blue" outlined @click="updateExpirationDate">수정</c-btn>
													<c-btn v-if="this.updateExpirationDateDialog === true" class="mx-1" color="grey" outlined @click="updateExpirationDateDialog = false">취소</c-btn>
											</v-col>
										</v-row>
										<v-divider class="mt-3 mb-3"></v-divider>
										<v-row align="center">
											<v-col cols="12" sm="6" md="2">
												<span>발급 개수</span>
											</v-col>
											<v-col cols="12" sm="6" md="4">
												<span class="black--text">{{ this.voucherStateInfo.issueCnt }}</span>
											</v-col>
											<v-col cols="12" sm="6" md="2">
												<span>사용 개수</span>
											</v-col>
											<v-col cols="12" sm="6" md="4">
												<span class="black--text">{{ this.voucherStateInfo.useCnt  }}</span>
											</v-col>
											<v-col cols="12" sm="6" md="2">
												<span>남은 개수</span>
											</v-col>
											<v-col cols="12" sm="6" md="4">
												<span class="black--text">{{ this.voucherStateInfo.remainCnt }}</span>
											</v-col>
											<v-col cols="12" sm="6" md="2">
												<span>반환 개수</span>
											</v-col>
											<v-col cols="12" sm="6" md="4">
												<span class="red--text">{{ this.voucherStateInfo.backCnt }}</span>
											</v-col>
										</v-row>
									</div>
								</v-row>
							</c-card>
						</v-col>
					</v-row>
				</c-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="12" sm="12">
				<c-card outlined>
					<div class="page-title mb-3 font-weight-bold">바우처 사용 정보</div>
					<c-table
						:headers="tableHeader"
						:items="voucherLogInfo"
						itemKey="id"
						multi-sort
					>
					  <template #usedDate="{item}">
							{{ item.usedDate }}
						</template>
						<template #usedCustomer="{item}">
              <span style="cursor: pointer" @click="$router.push(`/customers/${voucherStateInfo.customerId.id}`)">
							  {{ item.usedCustomer }}
              </span> 
						</template>
						<template #isUsed="{item}">
							<span :class="setColor(item.isUsed)">{{ item.isUsed }}</span>
						</template>
						<template #isApproved="{item}">
							<span style="cursor: pointer" @click="item.approvementDetailId ? $router.push(`/approvement/${item.approvementDetailId.approvementId}`) : ''">{{ item.isApproved }}</span>
						</template>
					</c-table>
				</c-card>
			</v-col>
		</v-row>
  </v-container>
</template>

<script>
  export default {
    components: {

    },
    data() {
      return {

				expiredDate: this.$func.curDateString(),
				updateExpirationDateDialog: false,
				expiredMenu: false,
				voucherStateId: "",
				
				tableHeader: [
					{
						text: '사용일',
						value: 'usedDate',
						align: 'center',
						sortable: true,
					},
					{
						text: '사용 회원',
						value: 'usedCustomer',
						align: 'center',
						sortable: true,
					},
					{
						text: '사용 여부',
						value: 'isUsed',
						align: 'center',
						sortable: true,
					},
					{
						text: '승인 여부',
						value: 'isApproved',
						align: 'center',
						sortable: true,
					},
				],
				voucherStateInfo: {},
				voucherLogInfo: [],
      }
    },
    mounted() {
      const {id} = this.$route.params;
			this.reqvoucherLogInfoByVoucherStateId(id);
			this.voucherStateId = id;
		},
		watch: {
			updateExpirationDateDialog() {
				this.expiredDate = this.voucherStateInfo.expirationDate;
			}
		},
    methods: {
			async reqvoucherLogInfoByVoucherStateId(id) {
				try {
					const res = await this.$api.getvoucherLogInfoByVoucherStateId(id);

					/* if there is any voucherLog, then bring the voucherStateInfo from first item of List */
					const result = await this.$api.getVoucherStateInfoById(id);

					this.voucherStateInfo = result.data;

					this.voucherLogInfo = res.data.map((item) => {
            item.usedDate = item.created ? this.$func.dateToString(item.created) : '';
						item.usedCustomer = item.customerId ? item.customerId.name : '-';
						item.isUsed = item.state ? item.state.configName : '-';
						item.isApproved = item.approvementDetailId? item.approvementDetailId.state.configName : '-';
            return item;
          });
				} catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqvoucherLogInfoByVoucherStateId'});
        }
			},
			async updateExpirationDate() {
				try {
					let reqData = {
						id : this.voucherStateId,
						expirationDate : this.expiredDate,
					};

					const res = await this.$api.updateVoucherStateExpirationDateById(reqData);
					this.updateExpirationDateDialog = false;
					this.reqvoucherLogInfoByVoucherStateId(this.voucherStateId);
				} catch (err) {
          this.$store.commit('snackbar', {err, where: 'updateExpirationDate'});
        }
			},
			setColor(data) {
        if (data === '반환') {
          return 'red--text'
        }
			},
    },
  }
</script>

<style scoped>

</style>
